import React from 'react';
import "./data-policy.css";

export const DataPolicyComponent = () => {
  return (
    <div className="data-policy-container">
      <div>
      Privacy Notice
The Privacy Notice was last updated on 11 Apr, 2021.<br/><br/>
<h3>Questions or concerns</h3>
If you have any questions or concerns regarding this Privacy Notice, please send us a detailed message to mail@halalvote.com, and we will try to resolve your concerns.
<br/><br/>
<h3>1. Who is the Personal Information collector</h3>
halalvote.com is the data controller (Controller) and responsible for your Personal Information. 
<br/><br/>
<h3>2. What Personal Information we collect about you and when we collect it</h3>
<br/>
<table>
    <th>
        WHEN INFORMATION IS COLLECTED
    </th>
    <th>
        TYPE OF INFORMATION
    </th>
    <tr>
        <td>When you register</td>
        <td>Email, Username, Password</td>
    </tr>
</table>

<br/><br/>

<h3>3. How and with whom we share the Personal Information we collect</h3><br/>
We neither rent nor sell your Personal Information in personally identifiable form to anyone.

<br/><br/>
<h3>4. How we store and secure the Personal Information we collect</h3>
<br/>
We endeavor to protect the privacy of your account and other Personal Information we hold in our records.
<br/><br/>
Sensitive information such as passwords are stored in encrypted form. SSL is applied when transferring information and while you access the Services from a web browser.
<br/><br/>

<h3>5. What rights do you, as the data subject, have</h3>
<ul style={{ textAlign: 'left' }}>
    <li>The right of access</li>
    <li>The right to correction</li>
    <li>The right to erasure</li>
</ul>
      </div>
    </div>
  )
}